<template>
  <div class="flex flex-col items-center">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-20 h-20 fill-green-500">
      <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z" />
    </svg>
    <h1 class="mt-4 text-2xl text-center">{{ t('langua.step_result.title') }}</h1>
    <p class="mt-8">{{ t('langua.step_result.message') }}</p>
    <p class="py-8 text-2xl flex justify-center space-x-4">
      <span class="text-gray-400">&middot;</span>
      <span class="text-gray-400">&middot;</span>
      <span class="text-gray-400">&middot;</span>
    </p>
    <button
      class="self-center text-green-600 hover:text-green-500 transition duration-200 ease-in-out flex items-center"
      @click="$emit('step', 0)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6 mr-1 -my-1 fill-current" style="transform: rotate(-90deg) rotateX(180deg);">
        <path d="M18.537 19.567A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3a8 8 0 1 0-2.46 5.772l.997 1.795z" />
      </svg>
      {{ t('langua.step_result.restart_button_label') }}
    </button>
  </div>
</template>

<script>
  import useI18n from '@/composables/i18n'
  import useMelonAuth from '@/composables/melon-auth'

  export default {
    name: 'ResultView',

    setup () {
      const {t} = useI18n()

      useMelonAuth().stopWatchExpiration?.()

      return {
        t,
      }
    },
  }
</script>
